import { apiClient } from "./client";

export type ApiTokenRecord = {
  id: string;
  tenant_id: string;
  user_id: string;
  name: string;
  jti: string;
  expires_at: string;
  revoked_at: string | null;
  last_used_at: string | null;
  created_at: string;
};

export type ApiTokenCreated = {
  token: string;
  record: ApiTokenRecord;
};

export async function listApiTokens(): Promise<ApiTokenRecord[]> {
  const { data } = await apiClient.get<ApiTokenRecord[]>("/api/v1/api-tokens");
  return data;
}

export async function createApiToken(
  name: string,
  userId: string,
  ttlDays: number,
): Promise<ApiTokenCreated> {
  const { data } = await apiClient.post<ApiTokenCreated>("/api/v1/api-tokens", {
    name,
    user_id: userId,
    ttl_days: ttlDays,
  });
  return data;
}

export async function revokeApiToken(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/api-tokens/${id}`);
}
